import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PortalLayout from 'sub_components/Layout/PortalLayout';

export default function PortalLayoutWrapper(props) {
	const navigate = useNavigate();
	const location = useLocation();

	function navigateToPath(path, state) {
		navigate(path, state);
	}
	return <PortalLayout navigate={navigateToPath} location={location} {...props} />;
}
